import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Tab as Component } from './tab';
import type { TTab, ITabDeps } from './models';
import styles from './styles/tab.css';

export const Tab = createWidget<ITabDeps, TTab>({ styles })(Component);
